import React, { Component } from 'react'

export class BrokerDetails extends Component {
  render() {
    const details = this.props.details
    return (
      <div className='constainer-fluid'>
        <div className='col-xs-12 col-sm-6'>
          <label>
            <strong>Name</strong>
          </label>{' '}
          : &nbsp;
          <span>
            <small>{details.name}</small>
          </span>
        </div>
        <div className='col-xs-12 col-sm-6'>
          <label>
            <strong>Email</strong>
          </label>{' '}
          : &nbsp;
          <span>
            <small>{details.email}</small>
          </span>
        </div>
        <div className='col-xs-12 col-sm-6'>
          <label>
            <strong>Phone</strong>
          </label>{' '}
          : &nbsp;
          <span>
            <small>{details.phone}</small>
          </span>
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Common/BrokerDetails.js
 **/